import React from 'react'

export default function Navbar() {
    return (
        <nav className='navbar'>
            <h1>Getting hands on with API</h1>
            {/* <img src='https://wallpapercave.com/wp/r0l1Uva.jpg'></img> */}
        </nav>
    )
}
